import { useContext } from "react";
import { ToasterContext } from "./ToasterProvider";
export const useToaster = () => {
    return useContext(ToasterContext);
};
